import { render, staticRenderFns } from "./ValidatedDuplicateTable.vue?vue&type=template&id=5f5e02dc&scoped=true"
import script from "./ValidatedDuplicateTable.vue?vue&type=script&lang=js"
export * from "./ValidatedDuplicateTable.vue?vue&type=script&lang=js"
import style0 from "./ValidatedDuplicateTable.vue?vue&type=style&index=0&id=5f5e02dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5e02dc",
  null
  
)

export default component.exports